import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// static imports 
import Auth from "../pages/auth/Auth";
import Layout from "../components/Layout/Layout";
// import LazyCompWrapper from "../components/hoc/WithLazyComp";
import RouteError from "../components/route-error/RouteError";
import PublicTracking from "../pages/operations/tracking/PublicTracking";
import PincodeServiceability from "../pages/pincodeServiceability/PincodeServiceability";
import AwbPricing from "../pages/dashboard/awbPricing/AwbPricing";



// dynamic imports
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const LeaveApplication = lazy(() => import("../pages/dashboard/leave/LeaveApplication"));
const MyLeaveApplicationList = lazy(() => import("../pages/dashboard/leave/MyLeaveApplicationList"));
const AttendanceManagement = lazy(() => import("../pages/hr/attendance/AttendanceManagement"));
const AttendanceReport = lazy(() => import("../pages/hr/attendance/AttendanceReport"));
const AttendanceManagementLayout = lazy(() => import("../components/Layout/AttendanceManagementLayout"));
const MyAttendanceAndRegularizationLayout = lazy(() => import("../components/Layout/MyAttendanceAndRegularizationLayout"));
const MyAttendanceManagement = lazy(() => import("../pages/hr/attendance/MyAttendanceManagement"));
const AddHoliday = lazy(() => import("../pages/hr/attendance/holiday/AddHoliday"));
const EditHoliday = lazy(() => import("../pages/hr/attendance/holiday/EditHoliday"));
const HolidayList = lazy(() => import("../pages/hr/attendance/holiday/HolidayList"));
const EditAttendanceRegularization = lazy(() => import("../pages/hr/attendance/regularization/EditAttendanceRegularization"));
const MyRegularizationList = lazy(() => import("../pages/hr/attendance/regularization/MyRegularizationList"));
const RegularizationList = lazy(() => import("../pages/hr/attendance/regularization/RegularizationList"));
const EditLeaveApplication = lazy(() => import("../pages/hr/leaves/EditLeaveApplication"));
const LeaveApplicationList = lazy(() => import("../pages/hr/leaves/LeaveApplicationList"));
const AddBank = lazy(() => import("../pages/master/bank/AddBank"));
const BankList = lazy(() => import("../pages/master/bank/BankList"));
const EditBank = lazy(() => import("../pages/master/bank/EditBank"));

const BillingList = lazy(() => import("../pages/master/billing/BillingList"));
const EditBilling = lazy(() => import("../pages/master/billing/EditBilling"));
const BillingHistory = lazy(() => import("../pages/master/billing/BillingHistory"));
const BillingHistoryDetail = lazy(() => import("../pages/master/billing/BillingHistoryDetail"));
// const AddBranch = lazy(() => import("../pages/master/branch/AddBranch"));
// const BranchList = lazy(() => import("../pages/master/branch/BranchList"));
// const EditBranch = lazy(() => import("../pages/master/branch/EditBranch"));
const AddContent = lazy(() => import("../pages/master/content/AddContent"));
const ContentList = lazy(() => import("../pages/master/content/ContentList"));
const EditContent = lazy(() => import("../pages/master/content/EditContent"));

const AddCustomer = lazy(() => import("../pages/master/customer/AddCustomer"));
const CustomerImport = lazy(() => import("../pages/master/customer/CustomerImport"));
const CustomerLayout = lazy(() => import("../components/Layout/CustomerLayout"));
const EditCustomer = lazy(() => import("../pages/master/customer/EditCustomer"));
const CustomerDocuments = lazy(() => import("../pages/master/customer/CustomerDocuments"));
const CustomerRateList = lazy(() => import("../pages/master/customerRate/CustomerRateList"));
const CustomerValueAddedServices = lazy(() => import("../pages/master/customerVas/CustomerValueAddedServices"));
const CustomerList = lazy(() => import("../pages/master/customer/CustomerList"));
const CustomerUsers = lazy(() => import("../pages/master/customer/CustomerUsers"));
const CustomerReports = lazy(() => import("../pages/master/customer/CustomerReports"));

const AddCustomerUser = lazy(() => import("../pages/master/customerUser/AddCustomerUser"));
const EditCustomerUser = lazy(() => import("../pages/master/customerUser/EditCustomerUser"));
const CustomerUserList = lazy(() => import("../pages/master/customerUser/CustomerUserList"));
const ChangePasswordCustomerUser = lazy(() => import("../pages/master/customerUser/ChangePasswordCustomerUser"));

const AddDepartment = lazy(() => import("../pages/master/department/AddDepartment"));
const DepartmentList = lazy(() => import("../pages/master/department/DepartmentList"));
const EditDepartment = lazy(() => import("../pages/master/department/EditDepartment"));
const AddDistrict = lazy(() => import("../pages/master/district/AddDistrict"));
const DistrictList = lazy(() => import("../pages/master/district/DistrictList"));
const EditDistrict = lazy(() => import("../pages/master/district/EditDistrict"));

const DistrictBulkUpload = lazy(() => import("../pages/master/district/DistrictBulkUpload"));
const DistrictBulkUpdate = lazy(() => import("../pages/master/district/DistrictBulkUpdate"));


const DocketList = lazy(() => import("../pages/master/dockets/DocketList"));
const AddDriver = lazy(() => import("../pages/master/driver/AddDriver"));
const DriverList = lazy(() => import("../pages/master/driver/DriverList"));
const EditDriver = lazy(() => import("../pages/master/driver/EditDriver"));
const AddHub = lazy(() => import("../pages/master/hub/AddHub"));
const EditHub = lazy(() => import("../pages/master/hub/EditHub"));
const HubList = lazy(() => import("../pages/master/hub/HubList"));
const AddMode = lazy(() => import("../pages/master/mode/AddMode"));
const EditMode = lazy(() => import("../pages/master/mode/EditMode"));
const ModeList = lazy(() => import("../pages/master/mode/ModeList"));
const AddPackageType = lazy(() => import("../pages/master/parcel/AddPackageType"));
const EditPackageType = lazy(() => import("../pages/master/parcel/EditPackageType"));
const PackageTypeList = lazy(() => import("../pages/master/parcel/PackageTypeList"));

const AddPincode = lazy(() => import("../pages/master/pincode/AddPincode"));
const EditPincode = lazy(() => import("../pages/master/pincode/EditPincode"));
const PincodeList = lazy(() => import("../pages/master/pincode/PincodeList"));
const PincodeBulkUpdate = lazy(() => import("../pages/master/pincode/PincodeBulkUpdate"));
const PincodeBulkUpload = lazy(() => import("../pages/master/pincode/PincodeBulkUpload"));
const ExportPincode = lazy(() => import("../pages/master/pincode/ExportPincode"));


const VendorPincodeList = lazy(() => import("../pages/master/vendorPincode/VendorPincodeList"));
const AddVendorPincode = lazy(() => import("../pages/master/vendorPincode/AddVendorPincode"));
const BulkUploadVendorPincode = lazy(() => import("../pages/master/vendorPincode/BulkUploadVendorPincode"));
const ExportVendorPincode = lazy(() => import("../pages/master/vendorPincode/ExportVendorPincode"));
const BulkUpdateVendorPincode = lazy(() => import("../pages/master/vendorPincode/BulkUpdateVendorPincode"));
const EditVendorPincode = lazy(() => import("../pages/master/vendorPincode/EditVendorPincode"));

const RateList = lazy(() => import("../pages/master/rate/RateList"));
const AddRate = lazy(() => import("../pages/master/rate/AddRate"));
const RateImport = lazy(() => import("../pages/master/rate/RateImport"));

const VasTypesList = lazy(() => import("../pages/master/vasTypes/VasTypesList"));
const EditVasType = lazy(() => import("../pages/master/vasTypes/EditVasType"));
const AddVasType = lazy(() => import("../pages/master/vasTypes/AddVasType"));

const VasRateList = lazy(() => import("../pages/master/vasRates/VasRateList"));
const EditVasRate = lazy(() => import("../pages/master/vasRates/EditVasRate"));
const AddVasRate = lazy(() => import("../pages/master/vasRates/AddVasRate"));
const VasRuleListing = lazy(() => import("../pages/master/vasRules/VasRuleListing"));
const EditVasRule = lazy(() => import("../pages/master/vasRules/EditVasRule"));
const AddVasRule = lazy(() => import("../pages/master/vasRules/AddVasRule"));
const ValueAddedServices = lazy(() => import("../pages/master/valueAddedServices/ValueAddedServices"));

const AddRole = lazy(() => import("../pages/master/role/AddRole"));
const EditRole = lazy(() => import("../pages/master/role/EditRole"));
const RoleList = lazy(() => import("../pages/master/role/RoleList"));

const AddState = lazy(() => import("../pages/master/state/AddState"));
const EditState = lazy(() => import("../pages/master/state/EditState"));
const StateList = lazy(() => import("../pages/master/state/StateList"));
const StateBulkUpload = lazy(() => import("../pages/master/state/StateBulkUpload"));

const AddTa = lazy(() => import("../pages/master/ta/AddTa"));
const EditTa = lazy(() => import("../pages/master/ta/EditTa"));
const TaList = lazy(() => import("../pages/master/ta/TaList"));
const EditTat = lazy(() => import("../pages/master/tat/EditTat"));
const TatList = lazy(() => import("../pages/master/tat/TatList"));
const AddVehicleType = lazy(() => import("../pages/master/vehicle-type/AddVehicleType"));
const EditVehicleType = lazy(() => import("../pages/master/vehicle-type/EditVehicleType"));
const VehicleTypeList = lazy(() => import("../pages/master/vehicle-type/VehicleTypeList"));
const AddVehicle = lazy(() => import("../pages/master/vehicle/AddVehicle"));
const EditVehicle = lazy(() => import("../pages/master/vehicle/EditVehicle"));
const VehicleList = lazy(() => import("../pages/master/vehicle/VehicleList"));
const AddVendor = lazy(() => import("../pages/master/vendor/AddVendor"));
const EditVendor = lazy(() => import("../pages/master/vendor/EditVendor"));
const VendorList = lazy(() => import("../pages/master/vendor/VendorList"));
const AddWarehouse = lazy(() => import("../pages/master/warehouse/AddWarehouse"));
const EditWarehouse = lazy(() => import("../pages/master/warehouse/EditWarehouse"));
const WarehouseList = lazy(() => import("../pages/master/warehouse/WarehouseList"));

const AddZone = lazy(() => import("../pages/master/zone/AddZone"));
const EditZone = lazy(() => import("../pages/master/zone/EditZone"));
const ZoneList = lazy(() => import("../pages/master/zone/ZoneList"));
const ZoneBulkUpload = lazy(() => import("../pages/master/zone/ZoneBulkUpload"));

const AddAreaCode = lazy(() => import("../pages/master/area-code/AddAreaCode"));
const EditAreaCode = lazy(() => import("../pages/master/area-code/EditAreaCode"));
const AreaCodeList = lazy(() => import("../pages/master/area-code/AreaCodeList"));
const AreaCodeBulkUpload = lazy(() => import("../pages/master/area-code/AreaCodeBulkUpload"));

const DashboardPickupRequestList = lazy(() => import("../pages/operations/dashboard/DashboardPickupRequestList"));
const CreatePickupRequestSheet = lazy(() => import("../pages/operations/pickup-request-sheet/CreatePickupRequestSheet"));
const EditPickupRequestSheet = lazy(() => import("../pages/operations/pickup-request-sheet/EditPickupRequestSheet"));
const PickupRequestSheetList = lazy(() => import("../pages/operations/pickup-request-sheet/PickupRequestSheetList"));

const AddPickupRequest = lazy(() => import("../pages/operations/pickup-request/AddPickupRequest"));
const EditPickupRequest = lazy(() => import("../pages/operations/pickup-request/EditPickupRequest"));
const PickupRequestList = lazy(() => import("../pages/operations/pickup-request/PickupRequestList"));
const AddDepartmentPermission = lazy(() => import("../pages/permissions/AddDepartmentPermission"));
const AddPermission = lazy(() => import("../pages/permissions/AddPermission"));
const AddRolePermission = lazy(() => import("../pages/permissions/AddRolePermission"));
const AddSection = lazy(() => import("../pages/permissions/AddSection"));
const DepartmentSectionList = lazy(() => import("../pages/permissions/DepartmentSectionCheckboxForm"));
const PermissionList = lazy(() => import("../pages/permissions/PermissionList"));
const PermissionRoleCheckboxForm = lazy(() => import("../pages/permissions/PermissionRoleCheckboxForm"));
const SectionList = lazy(() => import("../pages/permissions/SectionList"));
const ActivityList = lazy(() => import("../pages/sales/activity/ActivityList"));
const AddActivity = lazy(() => import("../pages/sales/activity/AddActivity"));
const EditActivityLayout = lazy(() => import("../pages/sales/activity/EditActivityLayout"));
const AddSalesExpense = lazy(() => import("../pages/sales/expense/AddSalesExpense"));
const EditSalesExpense = lazy(() => import("../pages/sales/expense/EditSalesExpense"));
const SalesExpenseList = lazy(() => import("../pages/sales/expense/SalesExpenseList"));
const AddLead = lazy(() => import("../pages/sales/lead/AddLead"));
const EditLead = lazy(() => import("../pages/sales/lead/EditLead"));
const LeadList = lazy(() => import("../pages/sales/lead/LeadList"));
const AddMyActivity = lazy(() => import("../pages/sales/my_activities/AddMyActivity"));
const EditMyActivity = lazy(() => import("../pages/sales/my_activities/EditMyActivity"));
const MyActivityList = lazy(() => import("../pages/sales/my_activities/MyActivityList"));
const MySalesExpenseList = lazy(() => import("../pages/sales/my_expenses/MySalesExpenseList"));
const ConsolidatedSalesReports = lazy(() => import("../pages/sales/reports/ConsolidatedSalesReports"));
const SalesReports = lazy(() => import("../pages/sales/reports/SalesReports"));
const SalesReportsCustomerWise = lazy(() => import("../pages/sales/reports/SalesReportsCustomerWise"));
const LoadReport = lazy(() => import("../pages/sales/reports/LoadReport"));
const BillingReport = lazy(() => import("../pages/sales/reports/BillingReport"));
const SalesReportsLeadWise = lazy(() => import("../pages/sales/reports/SalesReportsLeadWise"));
const SalesReportsUserWise = lazy(() => import("../pages/sales/reports/SalesReportsUserWise"));
const AddUser = lazy(() => import("../pages/user/AddUser"));
const ChangePassword = lazy(() => import("../pages/user/ChangePassword"));
const EditUser = lazy(() => import("../pages/user/EditUser"));
const EditUserPermissions = lazy(() => import("../pages/user/EditUserPermissions"));
const UserList = lazy(() => import("../pages/user/UserList"));
const UserProfileLayout = lazy(() => import("../pages/user/UserProfileLayout"));
const NavPageHr = lazy(() => import("../pages/hr/NavPageHr"));
const PayrollManagementLayout = lazy(() => import("../components/Layout/PayrollManagementLayout"));
const Payroll = lazy(() => import("../pages/hr/payroll/runpayroll/Payroll"));
const PayrollAnalytics = lazy(() => import("../pages/hr/payroll/PayrollAnalytics"));
const PayrollAdmin = lazy(() => import("../pages/hr/payroll/PayrollAdmin"));
const PayrollReports = lazy(() => import("../pages/hr/payroll/PayrollReports"));
const PayrollPerks = lazy(() => import("../pages/hr/payroll/PayrollPerks"));
const Loans = lazy(() => import("../pages/hr/payroll/Loans"));
const ComponentClaims = lazy(() => import("../pages/hr/payroll/ComponentClaims"));
const Form16 = lazy(() => import("../pages/hr/payroll/Form16"));
const MyLeadList = lazy(() => import("../pages/sales/my_lead/MyLeadList"));
const EditMyLead = lazy(() => import("../pages/sales/my_lead/EditMyLead"));
// const AddMyLead = lazy(() => import("../pages/sales/my_lead/AddMyLead"));
const SalesFunnel = lazy(() => import("../pages/sales/sales-Funnel/SalesFunnel"));
const CreateAWB = lazy(() => import("../pages/operations/awb/CreateAWB"));
const UpdateAWB = lazy(() => import("../pages/operations/awb/UpdateAWB"));
const AWBListing = lazy(() => import("../pages/operations/awb/AWBListing"));
const OrderSummaryAWB = lazy(() => import("../pages/operations/awb/OrderSummaryAWB"));
const AWBImport = lazy(() => import("../pages/operations/awb/AWBImport"));
const AWBExport = lazy(() => import("../pages/operations/awb/AWBExport"));


const AWBUpdate = lazy(() => import("../pages/operations/awb/AWBUpdate"));

const LabelPrint = lazy(() => import("../pages/operations/label-print/LabelPrint"));
const LabelPrintPage = lazy(() => import("../pages/operations/label-print/LabelPrintPage"));
const CronStatus = lazy(() => import("../pages/master/location/listing/CronStatus"));

//Report-Type
const AddReportType = lazy(() => import("../pages/master/report-type/AddReportType"));
const EditReportType = lazy(() => import("../pages/master/report-type/EditReportType"));
const ReportTypeList = lazy(() => import("../pages/master/report-type/ReportTypeList"));

//Master Report
const AddMasterReport = lazy(() => import("../pages/master/masterReport/AddMasterReport"));
const EditMasterReport = lazy(() => import("../pages/master/masterReport/EditMasterReport"));
const MasterReportList = lazy(() => import("../pages/master/masterReport/MasterReportList"));

const AWBLayout = lazy(() => import("../components/Layout/AWBLayout"));
const MySpace = lazy(() => import("../pages/mySpace/MySpace"));
const RateCalc = lazy(() => import("../pages/dashboard/rateCalculator/RateCalc"));
const VendorServiceability = lazy(() => import("../pages/dashboard/vendorServiceability/VendorServiceability"));
const TripManagement = lazy(() => import("../pages/fleet/trip/TripManagement"));
const CreateFtlBooking = lazy(() => import("../pages/fleet/trip/ftl/CreateFtlBooking"));
const CreatePtlBooking = lazy(() => import("../pages/fleet/trip/CreatePtlBooking"));
const EditFTLTripLayout = lazy(() => import("../components/Layout/EditFTLTripLayout"));
const EditFleetBookingData = lazy(() => import("../pages/fleet/trip/ftl/EditFTLData"));
const Tracking = lazy(() => import("../pages/fleet/trip/Tracking"));
const FTLOverview = lazy(() => import("../pages/fleet/trip/ftl/FTLOverview"));
const TripAwbListing = lazy(() => import("../pages/fleet/trip/TripAwbListing"));
const LastMileLayout = lazy(() => import("../components/Layout/LastmileLayout"));
const MiddleMileLayout = lazy(() => import("../components/Layout/MiddleMileLayout"));
const DeliveryRunSheetTable = lazy(() => import("../pages/operations/last-mile/drs/DeliveryRunSheetTable"));
const AddDeliveryRunSheet = lazy(() => import("../pages/operations/last-mile/drs/AddDeliveryRunSheet"));
const UpdateDeliveryRunSheet = lazy(() => import("../pages/operations/last-mile/drs/UpdateDeliveryRunSheet"));
const DeliveryStock = lazy(() => import("../pages/operations/last-mile/delivery-stock/DeliveryStock"))
const OutForDelivery = lazy(() => import("../pages/operations/last-mile/ofd/OutForDelivery"));
const ProofOfDelivery = lazy(() => import("../pages/operations/last-mile/pod/ProofOfDelivery"));
const DispatchStock = lazy(() => import("../pages/operations/middle-mile/dispatch-stock/DispatchStock"));
const LocationList = lazy(() => import("../pages/master/location/LocationList"));
const EditLocation = lazy(() => import("../pages/master/location/EditLocation"));
const AddLocation = lazy(() => import("../pages/master/location/AddLocation"));
const AssignedLocations = lazy(() => import("../pages/user/AssignedLocations"));
const ExceptionLayout = lazy(() => import("../components/Layout/ExceptionLayout"));
const ExceptionList = lazy(() => import("../pages/exceptions/ExceptionList"));
const PtlList = lazy(() => import("../pages/fleet/trip/PtlList"));
const PodManagement = lazy(() => import("../pages/operations/pod/PodManagement"));

export default function AppRoutes() {
  return (
    <>
      <Routes>
        {/* <Route path="/" element={<Navigate to="/auth" />} /> */}
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/label" element={<LabelPrintPage />} />
        <Route path="/public-tracking" element={<PublicTracking />} />
        <Route path="/pincode-service" element={<PincodeServiceability />} />

        <Route element={<Layout />} errorElement={<RouteError />} >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/rate-calculator" element={<RateCalc />} />
          <Route path="/vendor-serviceability" element={<VendorServiceability />} />
          <Route path="/awb-pricing" element={<AwbPricing />} />
          <Route path="/my-space" element={<MySpace />} />
          <Route path="/user-me" element={<UserProfileLayout />}>
            <Route index element={<>profile page</>} />
            <Route path="about" element={<>About page</>} />
            <Route path="job" element={<>job page</>} />
            <Route path="documents" element={<>documents page</>} />
            <Route path="assets" element={<>assets page</>} />
          </Route>

          <Route path="/fleet" errorElement={<RouteError />}>
            <Route index element={<TripManagement />} />
            <Route path="trips" element={<TripManagement />} />
            <Route path="trips/add-ftl-booking" element={<CreateFtlBooking />} />
            <Route path="trips/add-ptl-booking" element={<CreatePtlBooking />} />

            <Route path="trips/ptl" element={<PtlList />} />
            <Route path="trips/ptl/:ptlId" element={<>Ptl listing</>} />

            <Route path="trips/:tripId" element={<EditFTLTripLayout />}>
              <Route index element={<FTLOverview />} />
              <Route path="data" element={<EditFleetBookingData />} />
              <Route path="tracking" element={<Tracking />} />
              <Route path="awb" element={<TripAwbListing />} />
            </Route>

          </Route>

          <Route path='/master' errorElement={<RouteError />}>

            <Route index element={<UserList />} />
            <Route path='users' element={<UserList />} />
            <Route path='users/:userId' element={<EditUser />} />
            <Route path='users/:userId/password' element={<ChangePassword />} />
            <Route path='add-user' element={<AddUser />} />
            <Route path='users/assigned-locations/:userId' element={<AssignedLocations />} />

            <Route path='customerUser' element={<CustomerUserList />} />
            <Route path='customerUser/:customerUserId' element={<EditCustomerUser />} />
            <Route path='customerUser/:customerUserId/password' element={<ChangePasswordCustomerUser />} />
            <Route path='add-customerUser' element={<AddCustomerUser />} />

            {/* <Route path='branches' element={<BranchList />} />
            <Route path='branches/:branchId' element={<EditBranch />} />
            <Route path='add-branch' element={<AddBranch />} /> */}

            <Route path='customers' element={<CustomerList />} />
            <Route path='customers/:customerId' element={<CustomerLayout />}>

              <Route index element={<EditCustomer />} />
              <Route path="update" element={<EditCustomer />} />
              <Route path="documents" element={<CustomerDocuments />} />

              <Route path="pricing" element={<CustomerRateList />} />

              <Route path="vas" element={<CustomerValueAddedServices />} />
              <Route path="users" element={<CustomerUsers />} />
              <Route path="reports" element={<CustomerReports />} />
            </Route>
            <Route path='add-customer' element={<AddCustomer />} />
            <Route path='customers/import' element={<CustomerImport />} />

            <Route path='vehicles' element={<VehicleList />} />
            <Route path='vehicles/:vehicleId' element={<EditVehicle />} />
            <Route path='add-vehicle' element={<AddVehicle />} />

            <Route path='vehicle-types' element={<VehicleTypeList />} />
            <Route path='vehicle-types/:vehicleTypeId' element={<EditVehicleType />} />
            <Route path='add-vehicle-type' element={<AddVehicleType />} />

            <Route path='banks' element={<BankList />} />
            <Route path='banks/:bankId' element={<EditBank />} />
            <Route path='add-bank' element={<AddBank />} />

            <Route path='billings' element={<BillingList />} />
            <Route path='billings/history' element={<BillingHistory />} />
            <Route path='billings/history/:historyId' element={<BillingHistoryDetail />} />
            <Route path='billings/:billingId' element={<EditBilling />} />

            <Route path='zones' element={<ZoneList />} />
            <Route path='zones/:zoneId' element={<EditZone />} />
            <Route path='add-zones' element={<AddZone />} />
            <Route path='zones-bulk-upload' element={<ZoneBulkUpload />} />

            <Route path='area-code' element={<AreaCodeList />} />
            <Route path='area-code/:areaId' element={<EditAreaCode />} />
            <Route path='add-area-code' element={<AddAreaCode />} />
            <Route path='area-code-bulk-upload' element={<AreaCodeBulkUpload />} />


            <Route path='drivers' element={<DriverList />} />
            <Route path='drivers/:driverId' element={<EditDriver />} />
            <Route path='add-driver' element={<AddDriver />} />

            <Route path='modes' element={<ModeList />} />
            <Route path='modes/:modeId' element={<EditMode />} />
            <Route path='add-mode' element={<AddMode />} />

            <Route path='departments' element={<DepartmentList />} />
            <Route path='departments/:departmentId' element={<EditDepartment />} />
            <Route path='add-department' element={<AddDepartment />} />

            <Route path='content' element={<ContentList />} />
            <Route path='content/:contentId' element={<EditContent />} />
            <Route path='add-content' element={<AddContent />} />

            <Route path='packageTypes' element={<PackageTypeList />} />
            <Route path='packageTypes/:packageTypeId' element={<EditPackageType />} />
            <Route path='add-packageType' element={<AddPackageType />} />

            <Route path='roles' element={<RoleList />} />
            <Route path='roles/:roleId' element={<EditRole />} />
            <Route path='add-role' element={<AddRole />} />

            <Route path='pincodes' element={<PincodeList />} />
            <Route path='pincodes/:pincode' element={<EditPincode />} />
            <Route path='add-pincode' element={<AddPincode />} />
            <Route path='update-pincodes' element={<PincodeBulkUpdate />} />
            <Route path='pincodes-bulk-upload' element={<PincodeBulkUpload />} />
            <Route path='pincodes-export' element={<ExportPincode />} />

            <Route path='vendor-pincodes' element={<VendorPincodeList />} />
            <Route path='vendor-pincodes/:id' element={<EditVendorPincode />} />
            <Route path='add-vendor-pincode' element={<AddVendorPincode />} />
            <Route path='update-vendor-pincodes' element={<BulkUpdateVendorPincode />} />
            <Route path='vendor-pincodes-bulk-upload' element={<BulkUploadVendorPincode />} />
            <Route path='vendor-pincodes-export' element={<ExportVendorPincode />} />

            <Route path='states' element={<StateList />} />
            <Route path='states/:stateId' element={<EditState />} />
            <Route path='add-state' element={<AddState />} />
            <Route path='state-bulk-upload' element={<StateBulkUpload />} />

            <Route path='districts' element={<DistrictList />} />
            <Route path='districts/:districtId' element={<EditDistrict />} />
            <Route path='add-district' element={<AddDistrict />} />

            <Route path='districts-bulk-upload' element={<DistrictBulkUpload />} />
            <Route path='districts-bulk-update' element={<DistrictBulkUpdate />} />

            <Route path='hubs' element={<HubList />} />
            <Route path='hubs/:hubId' element={<EditHub />} />
            <Route path='add-hub' element={<AddHub />} />

            <Route path='vendors' element={<VendorList />} />
            <Route path='vendors/:vendorId' element={<EditVendor />} />
            <Route path='add-vendor' element={<AddVendor />} />

            <Route path='tat' element={<TatList />} />
            <Route path='tat/:tatId' element={<EditTat />} />

            <Route path='rates' element={<RateList />} />
            <Route path='add-rate' element={<AddRate />} />
            <Route path='rates-bulk-upload' element={<RateImport />} />

            <Route path='vasTypes' element={<VasTypesList />} />
            <Route path='vasTypes/:vasTypesId' element={<EditVasType />} />
            <Route path='add-vasTypes' element={<AddVasType />} />

            <Route path='vasRates' element={<VasRateList />} />
            <Route path='vasRates/:vasRatesId' element={<EditVasRate />} />
            <Route path='add-vasRates' element={<AddVasRate />} />

            <Route path='vasRules' element={<VasRuleListing />} />
            <Route path='vasRules/:vasRuleId' element={<EditVasRule />} />
            <Route path='add-vasRules' element={<AddVasRule />} />

            <Route path='value-added-services' element={<ValueAddedServices />} />

            <Route path='warehouses' element={<WarehouseList />} />
            <Route path='warehouses/:warehouseId' element={<EditWarehouse />} />
            <Route path='add-warehouse' element={<AddWarehouse />} />

            <Route path='ta' element={<TaList />} />
            <Route path='add-ta' element={<AddTa />} />
            <Route path='ta/:taId' element={<EditTa />} />

            <Route path='dockets' element={<DocketList />} />
            <Route path='add-docket' element={<AddTa />} />
            <Route path='dockets/:docketId' element={<EditTa />} />

            <Route path='locations' element={<LocationList />} />
            <Route path='locations/:locationId' element={<EditLocation />} />
            <Route path='add-location' element={<AddLocation />} />

          </Route>

          <Route path="/sales" errorElement={<RouteError />}>

            <Route index element={<LeadList />} />
            <Route path='leads' element={<LeadList />} />
            <Route path='leads/:leadId' element={<EditLead />} />
            <Route path='add-lead' element={<AddLead />} />

            <Route path='my-leads' element={<MyLeadList />} />
            <Route path='my-leads/:leadId' element={<EditMyLead />} />
            {/* <Route path='add-my-lead' element={<AddMyLead />} /> */}


            <Route path='activities' element={<ActivityList />} />
            <Route path='activities/:activityId' element={<ActivityList />} />
            <Route path='activities/edit/:activityId' element={<EditActivityLayout />} />
            <Route path='add-activity' element={<AddActivity />} />

            <Route path='my-activities' element={<MyActivityList />} />
            <Route path='my-activities/:myActivityId' element={<EditMyActivity />} />
            <Route path='add-my-activities' element={<AddMyActivity />} />

            <Route path='expenses' element={<SalesExpenseList />} />
            <Route path='my-expenses' element={<MySalesExpenseList />} />

            <Route path='expenses/:expenseId' element={<EditSalesExpense />} />
            <Route path='add-sales-expense' element={<AddSalesExpense />} />

            <Route path='sales-Funnel' element={<SalesFunnel />} />

            <Route path='reports'>
              <Route index element={<SalesReports />} />
              <Route path="user-wise" element={<SalesReportsUserWise />} />
              <Route path="lead-wise" element={<SalesReportsLeadWise />} />
              <Route path="customer-wise" element={<SalesReportsCustomerWise />} />
              <Route path="consolidated" element={<ConsolidatedSalesReports />} />
              <Route path="load-report" element={<LoadReport />} />
              <Route path="billing-report" element={<BillingReport />} />
            </Route>

          </Route>

          <Route path="/hr" errorElement={<RouteError />}>
            <Route index element={<NavPageHr />} />
            <Route path="attendance-management" element={<AttendanceManagementLayout />}>
              <Route index element={<AttendanceManagement />} />
              <Route path="regularization" element={<RegularizationList />} />
              <Route path="holiday" element={<HolidayList />} />
            </Route>

            <Route path="attendance-management/regularization/:regularizationId" element={<EditAttendanceRegularization />} />
            <Route path="attendance-management/holiday/add-holiday" element={<AddHoliday />} />
            <Route path="attendance-management/holiday/:holidayId" element={<EditHoliday />} />

            <Route path="my-attendance" element={<MyAttendanceAndRegularizationLayout />}>
              <Route index element={<MyAttendanceManagement />} />
              <Route path="my-regularization" element={<MyRegularizationList />} />
            </Route>

            <Route path="attendance-report" element={<AttendanceReport />} />
            <Route path="leave-management" element={<LeaveApplicationList />} />
            <Route path="leave-management/:leaveId" element={<EditLeaveApplication />} />
            <Route path="my-leaves" element={<MyLeaveApplicationList />} />
            <Route path="apply-leave" element={<LeaveApplication />} />

            <Route path="payroll" element={<PayrollManagementLayout />}>
              <Route index element={<Payroll />} />
              <Route path="analytics" element={<PayrollAnalytics />} />
              <Route path="admin" element={<PayrollAdmin />} />
              <Route path="reports" element={<PayrollReports />} />
              <Route path="perks" element={<PayrollPerks />} />
              <Route path="loans" element={<Loans />} />
              <Route path="component-claims" element={<ComponentClaims />} />
              <Route path="form-16" element={<Form16 />} />
            </Route>

          </Route>

          <Route path="/permissions" errorElement={<RouteError />}>
            <Route index element={<PermissionList />} />
            <Route path="permission" element={<PermissionList />} />
            <Route path="section" element={<SectionList />} />
            <Route path="add-permission" element={<AddPermission />} />
            <Route path='edit/:userId' element={<EditUserPermissions />} />
            <Route path="add-section" element={<AddSection />} />
            <Route path="department-section" element={<DepartmentSectionList />} />
            <Route path="add-department-permission" element={<AddDepartmentPermission />} />
            <Route path="role-permission" element={<PermissionRoleCheckboxForm />} />
            <Route path="add-role-permission" element={<AddRolePermission />} />
          </Route>

          <Route path="/operations" errorElement={<RouteError />}>
            <Route index element={<PickupRequestList />} />
            <Route path="pickup-request" element={<PickupRequestList />} />
            <Route path="pickup-request/:pickuprequestId" element={<EditPickupRequest />} />
            <Route path="add-pickup-request" element={<AddPickupRequest />} />

            <Route path="pickup-request/dashboard" element={<DashboardPickupRequestList />} />
            <Route path="pickup-request-sheet" element={<PickupRequestSheetList />} />
            <Route path="pickup-request-sheet/:prsId" element={<EditPickupRequestSheet />} />
            <Route path="add-pickup-request-sheet" element={<CreatePickupRequestSheet />} />

            <Route path="awb" element={<AWBListing />} />
            <Route path="awb/create" element={<CreateAWB />} />
            <Route path="awb/import" element={<AWBImport />} />
            <Route path="awb/export" element={<AWBExport />} />

            <Route path="awb/update" element={<AWBUpdate />} />
            <Route path="pod" element={<PodManagement />} />

            <Route path="label-print" element={<LabelPrint />} />
            <Route path="label" element={<LabelPrintPage />} />
            <Route path="cronstatus" element={<CronStatus />} />

            {/* Report-Type */}
            <Route path="report-type" element={<ReportTypeList />} />
            <Route path="report-type/:reportTypeId" element={<EditReportType />} />
            <Route path="add-report-type" element={<AddReportType />} />

            {/* Master Report */}
            <Route path="master-report" element={<MasterReportList />} />
            <Route path="master-report/:masterReportId" element={<EditMasterReport />} />
            <Route path="add-master-report" element={<AddMasterReport />} />

            <Route path="awb/:awbId" element={<AWBLayout />}>
              <Route index element={<Navigate to="summary" replace />} />
              <Route path="overview" element={<Navigate to="../summary" relative="path" replace />} />
              <Route path="update" element={<UpdateAWB />} />
              <Route path="summary" element={<OrderSummaryAWB />} />
              <Route path="tracking" element={<Navigate to="../summary" relative="path" replace />} />
            </Route>

            <Route path="delivery" element={<LastMileLayout />}>
              <Route index element={<DeliveryStock />} />
              <Route path="stock" element={<DeliveryStock />} />
              <Route path="drs" element={<DeliveryRunSheetTable />} />
              <Route path="ofd" element={<OutForDelivery />} />
              <Route path="pod" element={<ProofOfDelivery />} />
            </Route>

            <Route path="delivery/drs/add-drs" element={<AddDeliveryRunSheet />} />
            <Route path="delivery/drs/:drsId" element={<UpdateDeliveryRunSheet />} />

            <Route path="dispatch" element={<MiddleMileLayout />}>
              <Route index element={<DispatchStock />} />
              <Route path="stock" element={<DispatchStock />} />
            </Route>

          </Route>

          <Route path="/exceptions" element={<ExceptionLayout />}>
            <Route index element={<ExceptionList />} />
            <Route path="stock" element={<ExceptionList />} />
            <Route path="drs" element={<DeliveryRunSheetTable />} />
            <Route path="ofd" element={<OutForDelivery />} />
            <Route path="pod" element={<ProofOfDelivery />} />
          </Route>

          <Route path="*" element={<h1>Page Not Found</h1>} />
        </Route>

        <Route path='*' element={<Navigate to="/auth" />} />

      </Routes>
    </>
  );
}